// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aD6D","col":"styles_col__1w87H","actions":"styles_actions__2LUc8","conflict":"styles_conflict__2Hd5k"};